import LightOutlineProfile from "@svg/new-design/light-outline-profile";
import { toFarsiNumber } from "@utils/digits";
import { FC } from "react";

interface Props {
  profileName: string;
  mobile: string;
  email: string;
}
const ProfileInfo: FC<Props> = ({ profileName, mobile, email }) => {
  return (
    <div className="border-b border-b-fds-divider">
      <div className="py-4 fds-md:pt-0 pb-3 items-center fds-md:px-6  px-fds-22 flex gap-x-2">
        <div className="rounded-full flex items-center justify-center  bg-fds-brand-light h-7 w-7">
          <LightOutlineProfile className="text-fds-primary h-4 w-4" />
        </div>
        <div className="flex flex-col">
          <p className="title-md-medium fds-md:title-lg text-fds-primary">
            {profileName}
            {mobile && (
              <span className="text-xs font-normal leading-28 ">{` (${toFarsiNumber(
                mobile
              )}) `}</span>
            )}
          </p>
          <p className="body-xsm text-fds-secondary">{email}</p>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
